import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ImageLinksPayload {
  imagesLinks?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  baseSiteId: any;
  image: any;
  imgLinks: Array<string> = [];

  constructor(
    protected meta: Meta,
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    private occEndpointsService: OccEndpointsService
  ) {}

  getConfigurations(): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('fields', 'DEFAULT');

    const httpOptions = {
      headers: this.headers,
      params: httpParams,
    };

    return this.http.get(this.occEndpointsService.buildUrl(`/getRegionConfig`), httpOptions).pipe(
      map((data) => data),
      catchError(this.errorHandlr)
    );
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
